module.exports = __webpack_public_path__ + "static/media/mgh_logo.352e1538.svg";